function startTitleMarquee() {
    const titleWrap = document.querySelector(".box1_main .title");
    const scrollBox = titleWrap?.querySelector(".box1_main .title_inner");



    if (!titleWrap || !scrollBox) {
        setTimeout(startTitleMarquee, 300);
        return;
    }



    // ✅关键：只保留原生节点，把所有克隆出来的子元素全部删掉
    // 找原始节点：带自定义标记，没有标记的都是克隆出来的
    let originNodes = Array.from(scrollBox.children).filter(el => !el.dataset.clone);



    // 如果第一次执行没有标记，打上标记
    if(originNodes.length === 0){
        originNodes = Array.from(scrollBox.children);
        originNodes.forEach(n=> n.dataset.clone = "origin");
    }
    // 清空容器，只放回原始DOM，清除所有克隆副本
    scrollBox.innerHTML = '';
    originNodes.forEach(item=> scrollBox.appendChild(item));




    // 复制两份用于无缝循环，打上克隆标记
    originNodes.forEach(item => {
        const c1 = item.cloneNode(true);
        c1.dataset.clone = "copy";
        scrollBox.appendChild(c1);



        const c2 = item.cloneNode(true);
        c2.dataset.clone = "copy";
        scrollBox.appendChild(c2);
    });




    setTimeout(() => {
        // 单项宽度 = 一屏宽度 100vw
        const singleItemWidth = window.innerWidth;
        // 原始一组总宽度
        const groupWidth = singleItemWidth * originNodes.length;



        const titleAnim = gsap.to(scrollBox, {
            x: -groupWidth,
            duration: 26,
            ease: "none",
            repeat: -1,
            onRepeat: () => {
                gsap.set(scrollBox, { x: 0 });
            }
        });



        // 保存处理函数方便后续removeEventListener
        const onMouseEnter = () => titleAnim.pause();
        const onMouseLeave = () => titleAnim.resume();



        titleWrap.addEventListener("mouseenter", onMouseEnter);
        titleWrap.addEventListener("mouseleave", onMouseLeave);




        // ✅ resize处理：移除once:true，加防抖，销毁动画+清理事件，再重启
        let resizeTimer = null;
        function handleResize(){
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(()=>{
                // 杀掉动画
                titleAnim.kill();
                gsap.set(scrollBox, { x: 0 });
                // 移除旧鼠标事件，防止重复绑定
                titleWrap.removeEventListener("mouseenter", onMouseEnter);
                titleWrap.removeEventListener("mouseleave", onMouseLeave);
                // 重新初始化
                startTitleMarquee();
            }, 150);
        }
        // 不要 once:true
        window.addEventListener("resize", handleResize);



    }, 100);
}
startTitleMarquee();




document.addEventListener('DOMContentLoaded', () => {
  let swiperInstance = null;
  let resizeTimer = null;



  function remToPx(remValue) {
    const rootFs = parseFloat(getComputedStyle(document.documentElement).fontSize);
    return remValue * rootFs;
  }



  function destroySwiper(){
    if(swiperInstance){
      swiperInstance.destroy(true,true);
      swiperInstance = null;
    }
  }


  // =====================Swiper Item悬浮变色 目标hue模式 JS只控制opacity =====================
  function bindSwiperItemHover(){
    gsap.utils.toArray(".swiper-slide .swiper_box").forEach((box)=>{
      box.onmouseenter = null;
      box.onmouseleave = null;

      const tint = box.querySelector(".img_tint");
      const title = box.querySelector(".swiper_title");
      if(!tint || !title) return;

      box.addEventListener("mouseenter", ()=>{
        gsap.to(tint, { opacity: 1, duration:0.3 });
        gsap.to(title, {color:"#ed7122", duration:0.3});
      })
      box.addEventListener("mouseleave", ()=>{
        gsap.to(tint, { opacity: 0, duration:0.3 });
        gsap.to(title, {color:"#000", duration:0.3});
      })
    })
  }
  // ======================================================================



  function initSwiper() {
    destroySwiper();
    const el = document.querySelector('.swiper_main .box-swiper');
    if (!el) return;



    swiperInstance = new Swiper(el, {
      loop: true,
      autoplay: {
        delay: 1000,
        disableOnInteraction: false
      },
      allowTouchMove: true,
      speed: 400,
      slidesPerView: 8,
      spaceBetween: remToPx(1.25),
      breakpoints:{
        750:{
          slidesPerView:8,
          spaceBetween: remToPx(1.25)
        },
        0:{
          slidesPerView:3,
          spaceBetween: remToPx(.5)
        }
      }
    });



    // 重建后重新给swiper_box添加随机错位类
    document.querySelectorAll(".main_box").forEach(el=>{
      const isBottom = Math.random() > 0.5;
      el.classList.add(isBottom ? "gap-bottom" : "gap-top");
    })


    bindSwiperItemHover();
  }



  initSwiper();
  bindSwiperItemHover();



  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      initSwiper();
    },150)
  })
})



//随机上下
document.querySelectorAll(".main_box").forEach(el=>{
  const isBottom = Math.random() > 0.5;
  if(isBottom){
    el.classList.add("gap-bottom");
  }else{
    el.classList.add("gap-top");
  }
})